import { useTemplateOwnerName } from '../../hooks/useTemplateOwnerName';
import type { DocumentTemplateDetail } from '../../types/documentTemplates.types';
import { LivePreviewCard } from './LivePreviewCard';
import { RecordCard } from './RecordCard';
import { VersionStatusCard } from './VersionStatusCard';

interface Props {
  template: DocumentTemplateDetail;
  onOpenDraft?: () => void;
}

export function TemplateSummaryRail({ template, onOpenDraft }: Props) {
  const ownerName = useTemplateOwnerName(template);

  return (
    <aside aria-label="Template summary" className="space-y-4">
      <VersionStatusCard
        published={template.published}
        draft={template.draft}
        hasDraft={template.hasDraft}
        onOpenDraft={onOpenDraft}
      />
      <RecordCard template={template} ownerName={ownerName} />
      {template.published && <LivePreviewCard templateId={template.id} publishedVersionId={template.published.id} />}
    </aside>
  );
}
